import config from "@/config"
import http from "@/utils/request"
export default {
	GetQrOrgCode: {
	    url: `${config.API_URL}/Org/GetQrOrgCode`,
	    name: "当面付",
	    post: async function (data) {
	        return await http.post(this.url, data, {
	            headers: {
	                //'response-status': 401
	            }
	        });
	    }
	},
	GetOrgList: {
	    url: `${config.API_URL}/OrgBankInfo/GetOrgList`,
	    name: "获取商户信息",
	    post: async function (data) {
	        return await http.post(this.url, data, {
	            headers: {
	                //'response-status': 401
	            }
	        });
	    }
	},
	SaveOrgBankInfo:{
	    url: `${config.API_URL}/OrgBankInfo/SaveOrgBankInfo`,
	    name: "保存商户银行信息",
	    post: async function (data) {
	        return await http.post(this.url, data, {
	            headers: {
	                //'response-status': 401
	            }
	        });
	    }
	},
	ReviewOrgBankInfo:{
	    url: `${config.API_URL}/OrgBankInfo/ReviewOrgBankInfo`,
	    name: "审核商户银行信息",
	    post: async function (data) {
	        return await http.post(this.url, data, {
	            headers: {
	                //'response-status': 401
	            }
	        });
	    }
	},
	ReloadOrgPay: {
	    url: `${config.API_URL}/SystemHelper/ReloadOrgPay`,
	    name: "当面付",
	    post: async function (data) {
	        return await http.post(this.url, data, {
	            headers: {
	                //'response-status': 401
	            }
	        });
	    }
	},
}
